import http from "./constants/http";
import resources from "./constants/resources";

const checkSiteConfig = async (body) => {
  const res = await http(resources.SITE_INFO).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};

export default checkSiteConfig;
